<div class="form-input-card p-4">
  <p-message severity="secondary"> {{ title() }}</p-message>

  <div class="my-4">{{ message() }}</div>

  <div class="p-field mb-4">
    <textarea rows="5" cols="30" pTextarea [(ngModel)]="inputValue" class="w-full"></textarea>
  </div>

  <div class="flex justify-content-end gap-2">
    <p-button [label]="cancelText()" (click)="cancel()" severity="secondary"></p-button>
    <p-button [label]="acceptText()" (click)="accept()"></p-button>
  </div>
</div>
